import { hasRole } from '../shared/helper'

export default {
  components: {
  },
  data () {
    return {
    }
  },
  computed: {

  },
  created() {

  },
  methods: {
    hasRole (roleName) {
      return hasRole(roleName, this.$store)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/sidebar/sidebar.js